/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
export const isMetStationSharepointLocation = (location) => location?.startsWith(`${MET_STATION_SHAREPOINT_ROOT}/`) ?? false;
export const metstationPayloadSchema = z.object({
    name: z.string(),
    provider: z.string(),
    status: z.custom(),
    elevation: z.number().min(-400).max(6000),
    coordinates: z.array(z.number()).min(2).max(2),
    sharepoint_location: z.string().refine(isMetStationSharepointLocation),
    project_id: z.string().optional(),
});
export const newMetstationPayloadSchema = metstationPayloadSchema.extend({
    project_id: z.string(),
});
export const MET_STATION_SHAREPOINT_ROOT = '/poweralpha/PowerAlpha Application/MET Station data';
//# sourceMappingURL=met-stations.js.map